define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/def/Action",
	"csi/locale"
], function(declare,Controller,Action,locale) {

	return declare(Action, {
		hasAccess: function(/*csi.def.Context*/ctx) {
			if (!this.inherited(arguments))
				return null;

			var parent = ctx.getParent();
			if (parent && parent.$Type == "Theme") {
				return this.checkParentAccess(parent, null, ctx);
			} else {
				return true;
			}
		},

		getString: function(/*String*/suffix, /*String[]?*/params) {
			// summary: override parent behavior to optionally include success and/or error messages
			if (!params || params.length != 2) {
				return this.inherited(arguments);
			}

			var s = "";
			var succeeded = params[0];
			var failed = params[1];

			if (this.m_rcTarget) {
				// add success message
				if (succeeded > 0) {
					s += locale.typeAction(this.m_rcTarget.getType(), this.m_id + "_Success", [succeeded]);
				}

				// add fail message
				if (failed > 0) {
					s += locale.typeAction(this.m_rcTarget.getType(), this.m_id + "_Error", [failed]);
				}
			}

			return s;
		}
	});
});